<script>
export default {
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    styleButtonSearch() {
      const primary = this.$vuetify.theme.themes.light.primary || '#0e4859'
      return {
        height: '48px',
        background: `${primary} !important`,
        borderTop: '1px solid rgba(255, 255, 255, 0.2) !important',
        borderRight: '1px solid rgba(255, 255, 255, 0.2) !important',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2) !important',
        borderRadius: '0 5px 5px 0',
        minWidth: '0 !important',
        width: '40px !important'
      }
    }
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler(newValue) {
        if (newValue === '') {
          this.clearSearch()
        }
      }
    }
  },
  methods: {
    findDocuments() {
      if (this.searchQuery) {
        this.$emit('search', this.searchQuery)
        this.$inboxService
          .searchInbox(this.searchQuery)
          .then(response => {
            if (response.data.length === 0) {
              return this.$emit('found-documents', [])
            }
            return this.$emit('found-documents', response.data)
          })
          .catch(e => {
            console.error('Error searching inbox: ', e)
          })
      }
    },
    clearSearch() {
      this.searchQuery = ''
      return this.$emit('clear-search')
    }
  }
}
</script>
<template>
  <div class="search-container">
    <v-text-field
      id="inbox-search-input"
      v-model="searchQuery"
      :placeholder="$t('global.the.search')"
      solo
      clearable
      dense
      hide-details
      class="search-input"
      style="border-radius:5px 0 0 5px"
      @click:clear="clearSearch"
      @keydown.enter="findDocuments"
      @keydown.esc="clearSearch" />
    <v-btn
      id="inbox-search"
      color="primary"
      small
      class="search-btn"
      :style="styleButtonSearch"
      @click="findDocuments">
      <v-icon dark>mdi-magnify</v-icon>
    </v-btn>
  </div>
</template>
<style >
.search-container {
  display: flex;
  align-items: center;
  height: 48px;
}

.search-input {
  height: 48px;
  flex-grow: 1;
}
.v-input__slot{
  height: 48px;
}
</style>
